// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as CardThemeType$OrcaPaymentPage from "../Types/CardThemeType.bs.js";
import * as PaymentTypeContext$OrcaPaymentPage from "../Context/PaymentTypeContext.bs.js";

function PaymentInputField(props) {
  let __autocomplete = props.autocomplete;
  let __isDisabled = props.isDisabled;
  let __className = props.className;
  let __placeholder = props.placeholder;
  let __type_ = props.type_;
  let __name = props.name;
  let __isErrorHidden = props.isErrorHidden;
  let __isLabelHidden = props.isLabelHidden;
  let __fieldName = props.fieldName;
  let onFocus = props.onFocus;
  let errorString = props.errorString;
  let __rightIcon = props.rightIcon;
  let onBlur = props.onBlur;
  let value = props.value;
  let __inputFieldClassName = props.inputFieldClassName;
  let __fieldWidth = props.fieldWidth;
  let __height = props.height;
  let setIsValid = props.setIsValid;
  let __isValid = props.isValid;
  let __isValid_value = __isValid !== undefined ? Primitive_option.valFromOption(__isValid) : true;
  let __height_value = __height !== undefined ? __height : "";
  let __fieldWidth_value = __fieldWidth !== undefined ? __fieldWidth : "100%";
  let __inputFieldClassName_value = __inputFieldClassName !== undefined ? __inputFieldClassName : "";
  let __rightIcon_value = __rightIcon !== undefined ? __rightIcon : null;
  let __fieldName_value = __fieldName !== undefined ? __fieldName : "";
  let __isLabelHidden_value = __isLabelHidden !== undefined ? __isLabelHidden : false;
  let __isErrorHidden_value = __isErrorHidden !== undefined ? __isErrorHidden : false;
  let __name_value = __name !== undefined ? __name : "";
  let __type__value = __type_ !== undefined ? __type_ : "text";
  let __placeholder_value = __placeholder !== undefined ? __placeholder : "";
  let __className_value = __className !== undefined ? __className : "";
  let __isDisabled_value = __isDisabled !== undefined ? __isDisabled : false;
  let __autocomplete_value = __autocomplete !== undefined ? __autocomplete : "on";
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  let themeObj = match.themeObj;
  let config = match.config;
  let match$1 = config.appearance;
  let innerLayout = match$1.innerLayout;
  let match$2 = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.optionAtom);
  let match$3 = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.keys);
  let parentURL = match$3.parentURL;
  let iframeId = match$3.iframeId;
  let contextPaymentType = PaymentTypeContext$OrcaPaymentPage.usePaymentType();
  let paymentType = Core__Option.getOr(props.paymentType, contextPaymentType);
  let elementType = CardThemeType$OrcaPaymentPage.getPaymentModeToString(contextPaymentType);
  let match$4 = React.useState(() => false);
  let setInputFocused = match$4[1];
  let inputFocused = match$4[0];
  let handleFocus = ev => {
    setInputFocused(param => true);
    if (setIsValid !== undefined) {
      setIsValid(param => {});
    }
    if (onFocus !== undefined) {
      onFocus(ev);
    }
    Utils$OrcaPaymentPage.handleOnFocusPostMessage(iframeId, elementType, parentURL);
  };
  let handleBlur = ev => {
    setInputFocused(param => false);
    if (onBlur !== undefined) {
      onBlur(ev);
    }
    Utils$OrcaPaymentPage.handleOnBlurPostMessage(iframeId, elementType, parentURL);
  };
  let backgroundClass;
  switch (paymentType) {
    case "Payment" :
    case "PaymentMethodsManagement" :
      backgroundClass = themeObj.colorBackground;
      break;
    default:
      backgroundClass = "transparent";
  }
  let direction = __type__value === "password" || __type__value === "tel" ? "ltr" : "";
  let focusClass = inputFocused || value.length > 0 ? `mb-7 pb-1 pt-2 ` + themeObj.fontSizeXs + ` transition-all ease-in duration-75` : "transition-all ease-in duration-75";
  let floatinglabelClass = inputFocused ? "Label--floating" : "Label--resting";
  let getClassName = initialLabel => {
    if (value.length === 0) {
      return initialLabel + `--empty`;
    } else if (__isValid_value !== undefined) {
      if (__isValid_value) {
        return initialLabel + `--valid`;
      } else {
        return initialLabel + `--invalid`;
      }
    } else {
      return "";
    }
  };
  let labelClass = getClassName("Label");
  let inputClass = getClassName("Input");
  let inputLogoClass = getClassName("InputLogo");
  let inputClassStyles = innerLayout === "Spaced" ? "Input" : "Input-Compressed";
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
        condition: !__isLabelHidden_value && __fieldName_value.length > 0 && config.appearance.labels === "Above" && innerLayout === "Spaced",
        children: JsxRuntime.jsx("div", {
          children: __fieldName_value,
          "aria-hidden": true,
          className: `Label ` + labelClass,
          style: {
            fontSize: themeObj.fontSizeLg,
            fontWeight: themeObj.fontWeightNormal,
            marginBottom: "5px",
            opacity: "0.6"
          }
        })
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("input", {
                ref: Primitive_option.some(props.inputRef),
                "aria-label": `Type to fill ` + (
                  __fieldName_value.length > 0 ? __fieldName_value : __name_value
                ) + ` input`,
                className: inputClassStyles + ` ` + inputClass + ` ` + __className_value + ` focus:outline-none transition-shadow ease-out duration-200`,
                "data-testid": __name_value,
                id: props.id,
                style: {
                  background: __isDisabled_value ? themeObj.disabledFieldColor : backgroundClass,
                  height: __height_value,
                  padding: themeObj.spacingUnit,
                  width: __fieldWidth_value
                },
                autoComplete: __autocomplete_value,
                disabled: __isDisabled_value || match$2.readOnly,
                maxLength: props.maxLength,
                name: __name_value,
                pattern: props.pattern,
                placeholder: config.appearance.labels === "Above" ? __placeholder_value : "",
                type: __type__value,
                value: value,
                onFocus: handleFocus,
                onBlur: handleBlur,
                onChange: props.onChange
              }),
              JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
                condition: !__isLabelHidden_value && config.appearance.labels === "Floating",
                children: JsxRuntime.jsx("div", {
                  children: __fieldName_value,
                  "aria-hidden": true,
                  className: `Label ` + floatinglabelClass + ` ` + labelClass + ` absolute bottom-0 ml-3 ` + focusClass + ` pointer-events-none`,
                  style: {
                    fontSize: inputFocused || value.length > 0 ? themeObj.fontSizeXs : "",
                    marginBottom: inputFocused || value.length > 0 ? "" : themeObj.spacingUnit,
                    opacity: "0.6"
                  }
                })
              })
            ],
            className: `relative w-full ` + __inputFieldClassName_value
          }),
          JsxRuntime.jsx("div", {
            children: __rightIcon_value,
            className: `InputLogo ` + inputLogoClass + ` relative flex -ml-10 items-center`
          })
        ],
        className: "flex flex-row ",
        style: {
          direction: direction
        }
      }),
      JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
        condition: innerLayout === "Spaced" && !__isErrorHidden_value,
        children: errorString !== undefined ? JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
            condition: errorString.length > 0,
            children: JsxRuntime.jsx("div", {
              children: errorString,
              className: "Error pt-1",
              style: {
                alignSelf: "start",
                color: themeObj.colorDangerText,
                fontSize: themeObj.fontSizeSm,
                textAlign: "left"
              }
            })
          }) : null
      })
    ],
    className: "flex flex-col w-full",
    style: {
      color: themeObj.colorText
    }
  });
}

let make = PaymentInputField;

export {
  make,
}
/* jotai Not a pure module */
